export default "__VITE_ASSET__DBuDE7oD__"